import React from "react";
import { Route, BrowserRouter, Switch } from "react-router-dom";
import { createBrowserHistory } from "history";
import Login from "./pages/Login/Login";
import Dashboard from "./pages/Dashboard/Dashboard";
import Inventory from "./pages/Inventory/Inventory";
import PurchaseOrder from "./pages/PurchaseOrder/PurchaseOrder";
import Bpb from "./pages/Bpb/Bpb";
import ListVendor from "./pages/ListVendor/ListVendor";

const App = () => {
  const history = createBrowserHistory();
  if (history.location.pathname === "/") {
    history.push("/login");
  }

  return (
    <BrowserRouter>
      <Switch>
        <Route exact path="/login" component={Login} />
        <Route path="/dashboard" component={Dashboard} />
        <Route path="/bpb" component={Bpb} />
        <Route path="/inventory" component={Inventory} />
        <Route path="/purchase-order" component={PurchaseOrder} />
        <Route path="/list-vendor" component={ListVendor} />
      </Switch>
    </BrowserRouter>
  );
};

export default App;
